import React, { useState } from "react";
import { ICourse, ICourseNews } from "common/types";
import CourseNewsCreateModal from "./CourseNewsCreateModal";
import { Button, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../../../common/api";
import CourseNewsDeleteConfirmation from "./CourseNewsDeleteConfirmation";
import CourseNewsEditModal from "./CourseNewsEditModal";
import { BiEditAlt } from "react-icons/bi";

import "./CourseNews.css";
import { useAuth } from "../../../../authContext";

interface ICourseNewsProps {
  course: ICourse;
  setCourse: (course: ICourse) => void;
}

function CourseNews({ course, setCourse }: ICourseNewsProps) {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditNewsModal, setShowEditNewsModal] = useState(false);
  const [currentEditingNews, setCurrentEditingNews] = useState<ICourseNews>(
    {} as ICourseNews,
  );

  const { userProfile } = useAuth();

  const handleNewsCreate = (newsItem: ICourseNews) => {
    setCourse({
      ...course,
      news: [newsItem, ...course.news],
    });
  };

  const handleNewsUpdate = (updatedNewsItem: ICourseNews) => {
    setCourse({
      ...course,
      news: course.news.map((newsItem: ICourseNews) =>
        newsItem.id === updatedNewsItem.id ? updatedNewsItem : newsItem,
      ),
    });
    setShowEditNewsModal(false);
  };

  const hideCreateModal = () => setShowCreateModal(false);
  const hideEditModal = () => setShowEditNewsModal(false);

  async function deleteNews(newsItem: ICourseNews) {
    try {
      await api.delete(`/news/${newsItem.id}/`);
      setCourse({
        ...course,
        news: course.news.filter(
          (news: ICourseNews) => news.id !== newsItem.id,
        ),
      });
      toast.success("Novost obrisana");
    } catch (error) {
      console.log(error);
      toast.error("Greška prilikom brisanja novosti");
    }
  }

  return (
    <div>
      <div className="my-3">
        <Row className="align-items-center justify-content-between">
          <Col>
            <h4>Novosti</h4>
          </Col>
          <Col className="text-end">
            {userProfile?.role !== "STUDENT" && (
              <Button
                variant="primary"
                onClick={() => setShowCreateModal(true)}
              >
                Dodaj novost
              </Button>
            )}
          </Col>
        </Row>
      </div>

      <div className="newsContainer">
        {course?.news?.map((news: ICourseNews) => (
          <div className="newsItem" key={news.id}>
            <div className="titleAndEdit">
              <h4 className="newsTitle">{news.title}</h4>
              {userProfile?.role !== "STUDENT" && (
                <BiEditAlt
                  className="editIcon"
                  style={{ color: "darkgreen", cursor: "pointer" }}
                  onClick={() => {
                    setCurrentEditingNews(news);
                    setShowEditNewsModal(true);
                  }}
                  title={"Promijeni novost"}
                />
              )}
            </div>

            <p className="newsContent">{news.content}</p>

            <div className="dateAndDelete">
              <p className="newsDate">
                {new Date(news.created_at).toLocaleString("hr-HR")}
              </p>
              <CourseNewsDeleteConfirmation
                onDeleteConfirm={deleteNews}
                newsItem={news}
              />
            </div>
          </div>
        ))}
        {course?.news?.length === 0 && (
          <p className="text-muted">Trenutno nema novosti za ovu grupu</p>
        )}
      </div>

      <CourseNewsCreateModal
        show={showCreateModal}
        onHide={hideCreateModal}
        onNewsCreate={handleNewsCreate}
        course={course}
      />

      <CourseNewsEditModal
        show={showEditNewsModal}
        onHide={hideEditModal}
        onNewsUpdate={handleNewsUpdate}
        newsItem={currentEditingNews}
      />
    </div>
  );
}

export default CourseNews;
